<template>
  <div>
    <div v-if="chosenMethod == 'whatsapp'">
      <whatsapp
        @back="$emit('chooseMethod', '')"
        @sendReport="(phoneNumber) => $emit('sendReport', phoneNumber)"
        :loadingSending="loadingSending"
      />
    </div>
    <div v-if="chosenMethod == 'wechat'">
      <wechat @back="$emit('chooseMethod', '')" @sendReport="$emit('sendReport')" :loadingSending="loadingSending" :qrCodeLink="qrCodeLink"/>
    </div>
    <div v-if="chosenMethod == 'email'">
      <email
        @back="$emit('chooseMethod', '')"
        @sendReport="(email) => $emit('sendReport', email)"
        :loadingSending="loadingSending"
      />
    </div>
  </div>
</template>

<script>
import Wechat from "./wechat.vue";
import Whatsapp from "./whatsapp.vue";
import Email from "./email.vue";
export default {
  setup() {},
  components: {
    Wechat,
    Whatsapp,
    Email,
  },
  props: {
    chosenMethod: String,
    loadingSending: Boolean,
    qrCodeLink: String
  },
  emits: ["chooseMethod", "sendReport"],
};
</script>

<style scoped></style>
